import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
  standalone: true,
})
export class NumberOnlyDirective {
  private el = inject(ElementRef);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight'];

    // Autoriser les raccourcis avec Cmd (Mac) ou Ctrl (Windows/Linux)
    if (keyboardEvent.metaKey || keyboardEvent.ctrlKey) {
      return;
    }

    if (allowedKeys.includes(keyboardEvent.key)) {
      return;
    }

    if (!/[0-9]/.test(keyboardEvent.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const numbersOnly = pastedText.replace(/[^0-9]/g, '');

    if (numbersOnly) {
      const input = this.el.nativeElement as HTMLInputElement;
      const start = input.selectionStart ?? 0;
      const end = input.selectionEnd ?? 0;
      const currentValue = input.value;

      input.value = currentValue.substring(0, start) + numbersOnly + currentValue.substring(end);
      input.setSelectionRange(start + numbersOnly.length, start + numbersOnly.length);

      // Déclencher l'événement input pour notifier Angular du changement
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
